import React from 'react';
import { XIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { costRows, sundayNight } from '../data/copy';
export function ProblemSection() {
  return <section className="defer-paint w-full bg-sand py-10 sm:py-14" aria-labelledby="problem-heading" data-id="element-141" data-mp="30gxva0ohrloc">
      <div className="mx-auto max-w-5xl px-6" data-id="element-142" data-mp="2vqr53webzt3z">
        <SectionHeading eyebrow="💬 The Sunday night spiral" title={<span id="problem-heading" data-id="element-144" data-mp="39hcqpsv66h5k">Does this sound familiar?</span>} lead="You have a clinic tomorrow morning. You’re staring at a blank notebook or scrolling through random clips, trying to piece together a session that flows, makes sense for your players’ level, and actually looks professional." data-id="element-143" data-mp="2vowogua3en5p" />

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap justify-center gap-2" data-id="element-145" data-mp="3egpf4i1ovwa9">
          {sundayNight.map(line => <li key={line} className="rounded-full border border-line bg-shell px-4 py-2 font-sans text-[0.8rem] text-stone" data-id="element-146" data-mp="1p33sgleoqaqk">
              {line}
            </li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-2xl text-center" data-id="element-147" data-mp="jddb84xia6ty">
          <p className="font-display text-xl font-bold leading-snug text-ink sm:text-2xl" data-id="element-148" data-mp="jb0ntc8zb49i">
            It’s not that you don’t know pickleball. It’s that nobody gave you a
            structured system.
          </p>
          <p className="mx-auto mt-4 max-w-readable font-sans text-[0.95rem] leading-relaxed text-stone" data-id="element-149" data-mp="x4i6kutuccyh">
            You’ve been reinventing the wheel for every single class. The time
            you should spend resting is spent planning — and then there’s that
            nagging feeling that you could have been better prepared when you
            step onto the court.
          </p>
        </div>

        <div className="mt-11" data-id="element-150" data-mp="1g3dyfzi88f95">
          <h3 className="text-center font-display text-lg font-bold uppercase tracking-[0.1em] text-flame sm:text-xl" data-id="element-151" data-mp="1g3nofn39umeu">
            The high cost of being unstructured
          </h3>

          <div className="mt-6 overflow-hidden rounded-3xl border border-line bg-shell shadow-soft" data-id="element-152" data-mp="3hu7jh2azhooj">
            <table className="w-full border-collapse text-left" data-id="element-153" data-mp="ozqwu85ynpw2">
              <caption className="sr-only" data-id="element-154" data-mp="p23ml7hyn4jo">
                The cost of coaching without a structured system
              </caption>
              <thead data-id="element-155" data-mp="y1gonf3r8qud">
                <tr className="bg-navy-deep" data-id="element-156" data-mp="y1qdv0gz6tz0">
                  <th scope="col" className="px-5 py-3.5 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-shell sm:px-7" data-id="element-157" data-mp="xym4zpskfa20">
                    The problem
                  </th>
                  <th scope="col" className="px-5 py-3.5 font-sans text-[10px] font-semibold uppercase tracking-[0.18em] text-lime sm:px-7" data-id="element-158" data-mp="17ws3dxf5xy24">
                    The impact
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-159" data-mp="1cpl66fr2mwbk">
                {costRows.map(row => <tr key={row.problem} className="border-t border-line" data-id="element-160" data-mp="1cqmsjgdjf58l">
                    <th scope="row" className="px-5 py-4 align-top font-sans text-[0.85rem] font-medium leading-relaxed text-ink sm:px-7 sm:text-[0.9rem]" data-id="element-161" data-mp="1qqe65g056jm2">
                      <span className="flex items-start gap-2.5" data-id="element-162" data-mp="25ckxpnydcu4p">
                        <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-flame" strokeWidth={3} aria-hidden="true" data-id="element-163" data-mp="25a8hpgc68tua" />
                        {row.problem}
                      </span>
                    </th>
                    <td className="px-5 py-4 align-top font-sans text-[0.85rem] leading-relaxed text-stone sm:px-7 sm:text-[0.9rem]" data-id="element-164" data-mp="1wdppy7fofbza">
                      {row.impact}
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </div>

        <p className="mx-auto mt-9 max-w-xl text-center font-display text-xl font-bold leading-snug text-ink" data-id="element-165" data-mp="1rduz23vwime8">
          Stop wasting your freedom. You have the dedication —{' '}
          <span className="text-navy" data-id="element-166" data-mp="1hnihmkjdv9cb">now you need the system.</span>
        </p>
      </div>
    </section>;
}